// Shown when a Client Admin navigates to a module their Super Admin
// hasn't enabled. Friendly, branded, gives a clear "what to do next"
// path (back to dashboard + contact support).
import { Link } from "react-router-dom"
import { Lock, ArrowLeft, Mail } from "lucide-react"
import { MODULES, type ModuleKey } from "@/lib/module-access"

export default function ModuleLockedPage({ module }: { module: ModuleKey }) {
  const meta = MODULES[module]
  return (
    <div className="flex min-h-[60vh] items-center justify-center px-4">
      <div className="w-full max-w-md text-center">
        <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-slate-100 text-slate-500 dark:bg-slate-800 dark:text-slate-400">
          <Lock className="h-8 w-8" />
        </div>
        <h1 className="text-2xl font-bold tracking-tight text-slate-900 dark:text-slate-100">
          This module is not enabled for your account
        </h1>
        <p className="mt-2 text-sm text-slate-500 dark:text-slate-400">
          Contact your administrator to enable{" "}
          <strong className="text-slate-700 dark:text-slate-300">{meta.label}</strong> for your
          account.
        </p>
        <div className="mt-6 flex flex-col items-center gap-3">
          <Link
            to="/client/dashboard"
            className="inline-flex items-center gap-1.5 rounded-lg bg-indigo-600 px-4 py-2 text-sm font-semibold text-white hover:bg-indigo-700"
          >
            <ArrowLeft className="h-4 w-4" />
            Go to Dashboard
          </Link>
          <a
            href="mailto:support@byldgroup.com"
            className="inline-flex items-center gap-1.5 text-xs text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200"
          >
            <Mail className="h-3.5 w-3.5" />
            Need help? support@byldgroup.com
          </a>
        </div>
      </div>
    </div>
  )
}
